import { Model, Attr, HasMany } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'
import Country from '@/models/Country'

@Model()
export default class Region extends ApplicationRecord {
  static jsonapiType = 'regions'

  @Attr() id!: string
  @Attr() name!: string
  @Attr() code!: string
  @Attr() codeAlias!: string

  @HasMany() countries!: Country[]
}
